import React, { createContext, useContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuthSession } from "../AuthSessionProvider";
import { t } from "i18next";

const LanguageContext = createContext<any>(null);

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const { user } = useAuthSession() as any;

  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage?.getItem("lang") || user?.lang || "en"
  );
  const { i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(currentLanguage);
  }, [currentLanguage, i18n]);

  useEffect(() => {
    // Only fall back to the account's default language when the user
    // hasn't explicitly picked one yet, so a saved selection is never
    // overridden by the account default on remount/reload.
    if (!localStorage.getItem("lang") && user?.lang) {
      setCurrentLanguage(user.lang);
    }
  }, [user?.lang]);

  const changeLanguage = (language: string) => {
    setCurrentLanguage(language);
    localStorage.setItem("lang", language);
  };

  return (
    <LanguageContext.Provider
      value={{
        currentLanguage,
        translator: t,
        setCurrentLanguage: changeLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguageTranslator() {
  return useContext(LanguageContext);
}
